import { createSlotsContext } from '@grandvisionhq/slots';

const [ProductImageGallerySlotsProvider, useProductImageGallerySlots] = createSlotsContext({
    displayName: 'ProductDetailSlotsContext'
});

export { ProductImageGallerySlotsProvider, useProductImageGallerySlots };
//# sourceMappingURL=context.js.map
